module.exports = __webpack_public_path__ + "static/media/lapandmobile.6d53b0ce.png";